import ArticleList from './articleList';

export default ArticleList;
